// src/metaConfig.js
export const getMetaByCountry = (countryCode) => {
  const meta = {
    IN: {
      title: "Rock My Cart India: Global Shopping That Rocks",
    },
    SA: {
      title: "Rock My Cart Saudi Arabia: Global Shopping That Rocks",
    },
    AE: {
      title: "Rock My Cart UAE: Global Shopping That Rocks",
    },
    KW: {
      title: "Rock My Cart Kuwait: Global Shopping That Rocks",
    },
    UK: {
      title: "Rock My Cart United Kingdom: Global Shopping That Rocks",
    },
    GB: {
      title: "Rock My Cart United Kingdom: Global Shopping That Rocks",
    },
    OM: {
      title: "Rock My Cart Oman: Global Shopping That Rocks",
    },
    US: {
      title: "Rock My Cart USA: Global Shopping That Rocks",
    },
    BH: {
      title: "Rock My Cart Bahrain: Global Shopping That Rocks",
    },
    QA: {
      title: "Rock My Cart Qatar: Global Shopping That Rocks",
    },
  };

  return meta[countryCode] || meta["AE"]; // fallback to AE
};
